import React, { FC } from "react";
import UserLink from "../../utils/UserLink";
import { selectTrack, selectedTrack } from "../../store/actions/track";
import { likeSong, playsCounter } from "../../store/actions/songs";
import { playOrPause } from "../../store/actions/audio";
import { connect } from "react-redux";
import UIkit from "uikit";
import { fanMe } from "../../store/actions/users";
import { useEffect, useState } from "react";
import { firestore, storage, auth } from "../../firebase";
import { RootState } from "../../store/reducers";
import { Track } from "../../models/track";
import { Link, withRouter, match } from "react-router-dom";
import { motion } from "framer-motion";

interface RRProps<Params extends { id: string } = { id: string }> {
  history: any;
  location: any;
  match: match<Params>;
  staticContext?: any;
}

interface Props {
  track: Track;
}

type StateProps = {
  paused: boolean;
  current: Track;
  uid: string | string;
};

interface StateActions {
  selectedTrack: Function;
  playOrPause: Function;
  // fanMe: Function
  selectTrack: Function;
}

const TrackCard: FC<StateProps & StateActions & Props & RRProps> = ({
  track,
  current,
  paused,
  selectTrack,
  playOrPause,
  selectedTrack,
  uid,
  // fanMe,
}) => {
  const { id, title, username, covername } = track;
  const [likes, setLikes] = useState<string[]>([]);
  const [following, setFollowing] = useState(false);
  const [plays, setPlays] = useState([]);
  const [played, setPlayed] = useState(false);
  const [cover, setCover] = useState("");
  let liked = likes.includes(uid);

  const selectSong = (track: Track) => {
    if (played !== null && !played) {
      if (id && current.src !== track.src) playsCounter(id, uid);
    }

    if (current.id !== id) {
      selectTrack(track);
      playOrPause();
    } else {
      selectTrack(track);
      playOrPause();
    }
  };

  useEffect(() => {
    let loggedIn = auth.currentUser;
    let mounted = true;

    if (covername) {
      storage
        .ref(`covers/${track.uid}${covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) setCover(url);
        });
    }

    firestore
      .collection("songs")
      .doc(id)
      .onSnapshot((snap) => {
        if (snap.exists) {
          const data = snap.data();
          if (mounted) {
            // console.log(snap.data().likes)
            setLikes(data?.likes);
            setPlays(data?.plays);

            if (uid !== null) {
              setPlays(data?.plays);
              setPlayed(data?.plays.includes(uid));
            } else {
              setPlayed(false);
            }
          }
        }
      });

    if (loggedIn !== null) {
      firestore
        .collection("users")
        .where("username", "==", username)
        .onSnapshot((snap) => {
          if (!snap.empty) {
            snap.forEach((doc) => {
              const fans = doc.data().fans;
              if (fans.includes(loggedIn?.uid)) {
                if (mounted) {
                  setFollowing(true);
                }
              } else {
                if (mounted) {
                  setFollowing(false);
                }
              }
            });
          }
        });
    }

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="track">
      <div className="tr-bd">
        <div
          className="cover"
          style={{
            backgroundImage: cover ? `url(${cover})` : "",
            backgroundColor: `#ddd`,
            backgroundSize: "contain",
          }}
        >
          <span className="iswitch">
            <i
              className="material-icons-outlined md-24"
              onClick={() => {
                selectSong(track);
              }}
            >
              {current.id !== id || paused ? "play_arrow" : "pause"}
            </i>
            <span>{plays.length}</span>
          </span>
        </div>
        <div className="track-details">
          <div className="tr-hd">
            <div className="tr-artist">
              <UserLink params={{ username }}>
                <span
                  className="track-artist"
                  style={{ color: "var(--accent)" }}
                >
                  {username}
                </span>
              </UserLink>
            </div>
            <div
              className="tr-flw"
              onClick={() => {
                fanMe(username);
              }}
            >
              <i
                className="material-icons-outlined md-24"
                style={{ color: following ? "#00be65" : undefined }}
              >
                {following ? "how_to_reg" : "person_add"}
              </i>
            </div>
          </div>
          <div className="tr-inf smidek  app-text">{title}</div>
          <div className="tr-ac">
            <span
              className={`fv  ${liked ? `` : "app-text"}`}
              style={{ color: liked ? "#f57f17" : "var(--text-color)" }}
              onClick={() => {
                if (uid && id) {
                  likeSong(id);
                } else {
                  UIkit.modal.dialog(
                    `<p class="uk-modal-body">Login to use this feature</p>`,
                  );
                }
              }}
            >
              <span style={{ color: liked ? "#f57f17" : "var(--text-color)" }}>
                {likes.length}
              </span>
              <span>
                <motion.i
                  whileTap={{
                    scale: [1, 0.4, 1],
                  }}
                  initial={{
                    scale: 0.4,
                  }}
                  animate={{
                    scale: 1,
                    color: liked ? "#f57f17" : "var(--text-color)",
                  }}
                  className={`material-icons-outlined md-24  ${
                    liked ? `` : "app-text"
                  }`}
                  style={{ color: liked ? "#f57f17" : "" }}
                >
                  favorite_border
                </motion.i>
              </span>
            </span>
            <span>
              <span>
                <i className="material-icons-outlined md-24  app-text">share</i>
              </span>
            </span>
            <span>
              <Link to={`/comments/${track.id}`}>
                <span>
                  <i
                    className="material-icons-outlined md-24 app-text"
                    style={{ strokeWidth: "1px" }}
                  >
                    mode_comment
                  </i>
                </span>
              </Link>
            </span>
            <span>
              <span
                uk-toggle="target: #track-modal"
                onClick={() => selectedTrack(track)}
              >
                <i className="material-icons-outlined md-24  app-text">
                  more_horiz
                </i>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  current: state.songs.current,
  paused: state.songs.paused,
  uid: state.auth.user.id,
});

const mapDispatchToProps: StateActions = {
  playOrPause,
  selectedTrack,
  selectTrack,
  // fanMe,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrackCard),
);
